export default "__VITE_ASSET__Cu08d3Sm__"